import {useTranslation} from '/provider/TranslationProvider';

export function useClientsOverviewSection({
  onShowInfoPopover,
  onShowReport,
}: any) {
  const {tt, ts} = useTranslation('screen.clients.section.clientsOverview');

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Client Overview'),
      body: tt(
        'info.body',
        'View frontline Clients (your personal Clients), Generation Zero (Gen 0) Clients (those sponsored by you or a Coach on your team down to the first ED or above), or in your organization (all Clients on your team).',
      ),
    });

  const onItemPress = ({recordsName, value}: any) =>
    onShowReport({recordsName, loadingData: {total: value}});

  return {onInfoPress, onItemPress, tt, ts};
}
